// extracted by mini-css-extract-plugin
module.exports = {"footerContent":"styles_footerContent___aDUs","footer":"styles_footer__h8wch","visible":"styles_visible__pB9JW","dockedCTA":"styles_dockedCTA__9CEP6"};